<div class="-mt-5 w-full flex flex-col gap-4 justify-center">
  <lib-product-catalogue-setycore
    #productCatalogue
    [labels]="'lib.productCatalogue' | translate"
    class="w-full"
    [bank]="bank"
    [breadcrumbItems]="breadcrumbsLinks"
    [categories]="structuredCategoriesList"
    [selectedCategory]="currentCategory"
    [selectedSubcategory]="currentSubCategory"
    [selectedSubsubcategories]="currentSubSubCategories"
    [selectedBrands]="selectedBrands"
    [selectedStock]="selectedStock"
    [brands]="brands"
    [productsList]="productsList"
    [minListValue]="listMinPrice"
    [maxListValue]="listMaxPrice ?? maxPrice"
    [nubmerOfProducts]="dataTotalElements"
    [showPagination]="true"
    [totalElements]="dataTotalElements"
    [currentPage]="pagination.page > 0 ? pagination.page : pagination.page + 1"
    [rowsLimit]="rowsLimit"
    [state]="state"
    [initialSearchQuery]="searchQuerySubject.value"
    (categorySelected)="onSelectCategory($event)"
    (subcategorySelected)="onSelectSubCategory($event)"
    (subsubcategorySelected)="onSelectSubSubCategory($event)"
    (brandSelected)="onSelectBrand($event)"
    (stockSelected)="onSelectStock($event)"
    (minValueSelected)="onMinPriceSelected($event)"
    (maxValueSelected)="onMaxPriceSelected($event)"
    (selectedProduct)="navigateToProductsDetails($event)"
    (queryParamsChange)="onQueryParamsChange($event)"
    (contactButtonClicked)="contactClientService()"
    (priceOrderSelected)="onOrderPriceUpdated($event)"
    (addToCart)="onAddToCart($event)"
    [wishlistedIds]="(favoriteService.favoriteConfigurationIds$ | async) ?? []"
    (toggleWishlist)="onToggleWishlist($event)"
    (searchQueryChange)="onSearch($event)"
  ></lib-product-catalogue-setycore>

  <lib-add-product-popup-setycore
    [labels]="'lib.addProductPopup' | translate"
    [showPopup]="showAddPopup"
    [productName]="popupConfiguration?.name || ''"
    [Quantity]="popQuantity"
    [availableQuantity]="popupAvailableQuantity"
    [price]="popupConfiguration?.price || 0"
    [imgUrl]="popupConfiguration?.images?.[0]?.url || DEFAULT_PRODUCT_IMAGE"
    (showPopupChange)="onShowAddPopupChange($event)"
    (onseeCart)="onSeeCart()"
    (oncontinueShopping)="onContinueShopping()"
  ></lib-add-product-popup-setycore>

  @if (snackbar.visible) {
    <div class="relative z-[9999]">
      <lib-snackbar
        [bank]="bank"
        [labels]="'lib.snackbar' | translate"
        [theme]="snackbar.theme"
        [title]="snackbar.text"
        [showIconLeft]="true"
        [showIconRight]="false"
        [position]="'bottom'"
      ></lib-snackbar>
    </div>
  }
</div>
